export class Controller {

    /** @ngInject */
    constructor($q, $state, $uibModal, AccountsResource, Alert) {
        this.$q = $q;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    $onInit() {
        this.username = '';
    }

    save() {
        const rejectAlreadyExistingAccount = (account) => {
            if (account.justCreated) {
                return this.$q.resolve(account);
            } else {
                this.$uibModal
                    .open({component: 'companyUserDirectoriesManageUserAddAccountAccountAlreadyExists'}).result
                    .then(() => this.$state.go('company.user-directories.manage-account', {accountId: account.id}));
                return this.$q.reject();
            }
        };

        this.isSaving = true;
        this.AccountsResource
            .addNewUserAccount(this.companyId, this.username)
            .then(rejectAlreadyExistingAccount)
            .then(({id}) => this.$state.go('company.user-directories.manage-account', {accountId: id}))
            .then(() => this.Alert('success', 'company.user-directories.saaspass-users.sms-users.add.added'))
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/sms-users/add/add-sms-user.controller.js